import { put, call, all, fork, select, takeLatest } from "redux-saga/effects";
import { pdcsApiUpsellProvider, rangesApiUpsellProvider } from "../../lib/api/providers";

import {
  PDC_SET_PAGINATION,
  PDC_SET_LIST,
  PDC_SET_SORT,
  PDC_SET_METRICS,
  PDC_SET_RANGES,
  PDC_INIT,
  PDC_SET_KEY_FILTER_SELECTED,
  PDC_FILTERS_LOADING,
  PDC_SET_FILTERS
} from "../types";
const getState = state => state;
const getPdcState = state => state.pdcs;
const getPDCSApis = (pdcState, token) => {
  const { page, sort, currentFilters } = pdcState;

  return pdcsApiUpsellProvider
    .post(
      `/`,
      {
        match: { ...currentFilters },
        project: {
          pdc_label: 1,
          pdc_id: 1,
          cp: "$zip_code",
          retailer_label: "$retailer_label",
          retailer_id: 1,
          sector_label: "$sectors.sector_label",
          sectors: "$sectors",
          city: "$city",
          address: "$address",
          network_label: 1,
          typology_label: "$typology.label",
          _id: 0
        },
        sort,
        page: page > 0 ? page : 1
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getPDCSMetricsApis = (clientId, token) => {
  return pdcsApiUpsellProvider
    .get(`/metrics/${clientId}`, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};
const getRangesApi = token => {
  return rangesApiUpsellProvider
    .post(
      `/`,
      { project: { id: 1, label: 1, _id: 0 } },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};
function* getMetricsAndRanges() {
  try {
    const state = yield select(getState);
    const data = yield call(getPDCSMetricsApis, state.currentClient.id, state.auth.token);
    const dataRanges = yield call(getRangesApi, state.auth.token);
    yield put({ type: PDC_SET_METRICS, payload: data });
    yield put({ type: PDC_SET_RANGES, payload: dataRanges });
  } catch (e) {
    console.log(e.message);
  }
}
function* getPDCS() {
  try {
    const pdcState = yield select(getPdcState);
    const state = yield select(getState);
    const data = yield call(getPDCSApis, pdcState, state.auth.token);
    if (!Array.isArray(data.docs)) {
      throw new Error("No pdc");
    }

    yield put({ type: PDC_SET_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

const getFiltersValuesApi = state => {
  const currentFiltersToSend = { ...state.currentFilters };
  delete currentFiltersToSend[state.keyFilterSelected];

  return pdcsApiUpsellProvider
    .post(`/distincts/${state.keyFilterSelected}`, {
      match: currentFiltersToSend
    })
    .then((response = {}) => {
      return response.data;
    });
};
function* getFiltersValues() {
  try {
    yield put({ type: PDC_FILTERS_LOADING, loading: true });
    const state = yield select(getPdcState);
    const values = yield call(getFiltersValuesApi, state);

    if (values.length <= 0) {
      throw new Error("No filters");
    }
    yield put({
      type: PDC_SET_FILTERS,
      values: values,
      key: state.keyFilterSelected
    });
    yield put({ type: PDC_FILTERS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PDC_FILTERS_LOADING, loading: false });
  }
}

function* watchSetKeyFilterSelected() {
  yield takeLatest(PDC_SET_KEY_FILTER_SELECTED, getFiltersValues);
}
function* watchInit() {
  yield takeLatest(PDC_INIT, getMetricsAndRanges);
}

function* watchFetchPdcsPagination() {
  yield takeLatest(PDC_SET_PAGINATION, getPDCS);
}

function* watchFetchPdcsSort() {
  yield takeLatest(PDC_SET_SORT, getPDCS);
}
export default function* root() {
  yield all([
    fork(watchInit),
    fork(watchFetchPdcsPagination),
    fork(watchFetchPdcsSort),
    fork(watchSetKeyFilterSelected)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/pdcsSagas.js